@if (item.items) {
    <li>
        <a pRipple pStyleClass="@next" enterFromClass="hidden" enterActiveClass="slidedown"
            leaveToClass="hidden" leaveActiveClass="slideup"
            class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="{{item.icon}} mr-2"></i>
            <span class="font-medium">{{ item.label | translate }}</span>
            <i class="pi pi-chevron-down ml-auto"></i>
        </a>
        <ul class="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
            @for (item2 of item.items; track item2.label) {
                <app-sidebar-item [item]="item2"></app-sidebar-item>
            }
        </ul>
    </li>
}
@if (!item.items) {
    <li>
        <a pRipple [routerLink]="item.routerLink" [routerLinkActive]="['n-router-active']"
            class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="{{item.icon}} mr-2"></i>
            <span class="font-medium">{{ item.label | translate }}</span>
        </a>
    </li>
}


